module.exports = __webpack_public_path__ + "img/sp1.e4f2de42.png";